export const findImage = (mediaGroups, {isThumbnail = false, medium = 'image'}) => {
  if (!mediaGroups || mediaGroups.length === 0) {
    return null
  }
  const images = mediaGroups.filter(mg => (mg.medium || mg.type) === medium)
  const firstImg = images.length > 0 ? images[0] : null

  const first_image_renditions = firstImg && (firstImg.contents || firstImg.renditions)
  if (first_image_renditions) {
    let imgMatch = first_image_renditions.filter(c => c.size >= (isThumbnail ? 200 : 800) && c.size <= (isThumbnail ? 400 : 2000))
    if (imgMatch.length === 0) {
      imgMatch = first_image_renditions.filter(c => c.size > 600)
    }
    if (imgMatch.length === 0) {
      imgMatch = first_image_renditions.slice(0, 1)  // take any
    }
    return {
      title: firstImg.title || firstImg.headline,
      description: firstImg.description || firstImg.caption,
      creditline: firstImg.creditline,
      ...imgMatch[0]
    }
  }
  return null
}

export const findVideo = (mediaGroups, {medium = 'video'}) => {
  if (!mediaGroups || mediaGroups.length === 0) {
    return null
  }
  const videos = mediaGroups.filter(mg => (mg.medium || mg.type) === medium)
  const firstVid = videos.length > 0 ? videos[0] : null
  if (firstVid === null) return null

  const video_renditions = firstVid && (firstVid.contents || firstVid.renditions)
  if (video_renditions) {
    // Look for poster and raw
    const poster_rend = video_renditions.find((r) => r.role === "poster")
    const raw_rend = video_renditions.find((r) => r.role === "raw")
    return {
      title: firstVid.title || firstVid.headline,
      description: firstVid.description || firstVid.caption,
      creditline: firstVid.creditline,
      transcript: firstVid.transcript,
      poster: poster_rend ? poster_rend.url : null,
      url: raw_rend ? raw_rend.url : null,
      width: raw_rend ? raw_rend.width : null,
      height: raw_rend ? raw_rend.height : null,
      mimetype: raw_rend && raw_rend.mimetype ? raw_rend.mimetype.split("/")[1] : null,
      ...firstVid
    }
  }
  // no contents or urls via gql api available
  return {
    title: firstVid.title || firstVid.headline,
    description: firstVid.description || firstVid.caption,
    creditline: firstVid.creditline,
    ...firstVid
  }
}

export const findAudio = (mediaGroups, {medium = 'audio'}) => {
  if (!mediaGroups || mediaGroups.length === 0) {
    return null
  }
  const audios = mediaGroups.filter(mg => (mg.medium || mg.type) === medium)
  const firstAud = audios.length > 0 ? audios[0] : null
  if (firstAud === null) return null

  const video_renditions = firstAud && (firstAud.contents || firstAud.renditions)
  if (video_renditions) {
    // Look for poster and raw
    console.log('findAudio...', firstAud)
    const raw_rend = video_renditions.find((r) => r.role === "raw")
    return {
      title: firstAud.title || firstAud.headline,
      description: firstAud.description || firstAud.caption,
      creditline: firstAud.creditline,
      transcript: firstAud.transcript,
      url: raw_rend ? raw_rend.url : null,
      mimetype: raw_rend && raw_rend.mimetype ? raw_rend.mimetype.split("/")[1] : null,
      ...firstAud
    }
  }
  // no contents or urls via gql api available
  return {
    title: firstAud.title || firstAud.headline,
    description: firstAud.description || firstAud.caption,
    creditline: firstAud.creditline,
    ...firstAud
  }
}


// WEBPACK FOOTER //
// ./src/probish/utils.js